import { paymentService } from "../Api/Services/paymentService";
import { PaymentMethod } from "../Enums/PaymentMethod";

export type PaymentSyncSnapshot = {
  paymentMethod?: PaymentMethod | null;
  creditCardInstallments?: number | null;
};

type SyncPaymentMethodParams = {
  orderId: string;
  paymentMethod: PaymentMethod;
  creditCardInstallments?: number | null;
};

export const needsPaymentSync = (
  current: PaymentSyncSnapshot | null | undefined,
  target: PaymentSyncSnapshot
): boolean => {
  if (target.paymentMethod == null) {
    return false;
  }

  if (current?.paymentMethod == null) {
    return true;
  }

  if (current.paymentMethod !== target.paymentMethod) {
    return true;
  }

  const normalize = (value?: number | null) => value ?? null;

  if (target.paymentMethod === PaymentMethod.CreditCard) {
    return normalize(current.creditCardInstallments) !== normalize(target.creditCardInstallments);
  }

  return false;
};

export const syncPaymentMethod = async ({
  orderId,
  paymentMethod,
  creditCardInstallments = null
}: SyncPaymentMethodParams): Promise<boolean> => {
  return paymentService.updatePaymentMethod({
    orderId,
    paymentMethod,
    creditCardInstallments
  });
};
